module.exports = __webpack_public_path__ + "assets/img/2.c7647547.png";